/* eslint-disable no-console */

/**
 * @module M/control/ManagegridControl
 */

import ManagegridImplControl from 'impl/managegridcontrol';
import template from 'templates/managegrid';
import Choices from 'choices.js';
// import Cursor from '../assets/icons/cursor4.svg';

export default class ManagegridControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(config, params, namePanel) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(ManagegridImplControl)) {
      M.exception('La implementación usada no puede crear controles ManagegridControl');
    }
    // 2. implementation of this control
    const impl = new ManagegridImplControl();
    super(impl, 'Managegrid');

    this.groupLayers = config;
    this.initialParameters = params;
    this.namePanel = namePanel;

  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    if (!M.template.compileSync) { // JGL: retrocompatibilidad Mapea4
      M.template.compileSync = (string, options) => {
        let templateCompiled;
        let templateVars = { vars: { namePanel: this.namePanel } };
        let parseToHtml;
        if (!M.utils.isUndefined(options)) {
          templateVars = M.utils.extends(templateVars, options.vars);
          parseToHtml = options.parseToHtml;
        }
        const templateFn = Handlebars.compile(string);
        const htmlText = templateFn(templateVars);
        if (parseToHtml !== false) {
          templateCompiled = M.utils.stringToHtml(htmlText);
        } else {
          templateCompiled = htmlText;
        }
        return templateCompiled;
      };
    }

    return new Promise((success, fail) => {
      this.templateVars = { vars: { namePanel: this.namePanel } };
      const html = M.template.compileSync(template, this.templateVars);
      // Añadir código dependiente del DOM

      this.urlMunicipios = 'https://www.ideandalucia.es/services/DERA_g13_limites_administrativos/wfs?service=WFS&version=2.0.0&request=GetFeature&typename=DERA_g13_limites_administrativos:g13_01_TerminoMunicipal&propertyName=cod_mun,nombre,provincia&outputFormat=application/json';

      this.listFullMunicipios = new Array();

      this.layerToCharge = false;


      this.divMenus = html.querySelectorAll('div#divMenus')[0];
      this.divLeyenda = html.querySelectorAll('div#divLeyenda')[0];
      this.divOpacityRange = html.querySelectorAll('div#divOpacityRange')[0];
      this.divBusqueda = html.querySelectorAll('div#divBusqueda')[0];
      this.divCapas = html.querySelectorAll('div#divCapas')[0];

      this.selectYear = html.querySelectorAll('select#selectYear')[0];

      this.sumatorioGrid = 0;
      this.numberItemSelected = 0;

      this.mainVar;

      this.controlHoverFeatures = [false, false];

      this.controlGetFeatureInfoActivated = false;

      this.SeleccionGrid_layer = new M.layer.GeoJSON({
        name: 'Capa Seleccion Grid',
        source: {
          crs: {
            "type": "name",
            "properties": {
              "name": "urn:ogc:def:crs:EPSG::25830"
            }
          },
          features: [],
          type: "FeatureCollection"
        },
        extract: false
      });

      this.estiloSeleccionGrid = new M.style.Generic({
        name: 'Estilo_Seleccion',
        point: {
          radius: 5,
          fill: {
            color: '#88ff00',
            opacity: 0.5
          },
          stroke: {
            color: '#88ff00',
          }
        },
        polygon: {
          fill: {
            color: '#88ff00',
            opacity: 0,
          },
          stroke: {
            color: '#88ff00',
            width: 4
          },
          label: {
            text: '',           // Texto etiqueta. fijo|función|atributo
            font: 'bold 16px Courier New',  // Fuente de la etiqueta
            scale: 0.8,                     // Escala de la etiqueta
            offset: [0, 0],                // Desplazamiento en píxeles
            color: '#000',                  // Color del texto
            // Halo del texto
            stroke: {
              color: '#FFF',       // Color del halo
              width: 5,            // Grosor del halo
              //linedash: [5, 5, 20],  // Patrón de distancias
              linedashoffset: 1,   // Offset de fase
              linecap: 'round',   // Estilo de final de linea. round|square|butt
              linejoin: 'round',   // Estilo de conexión de segmentos. miter|round|bevel
              miterlimit: 15       // Tamaño máximo segmento de conexión
            },
            rotate: false,                 // Rotación con dispositivo
            rotation: 0,                 // Rotación de la etiqueta
            align: M.style.align.CENTER,    // Alineación horizontal. CENTER|LEFT|RIGHT
            baseline: M.style.baseline.MIDDLE, // Alineación vertical. TOP|BOTTOM|MIDDLE          
          }
        }
      });

      this.estiloSeleccionGrid_NoLabel = new M.style.Generic({
        name: 'Estilo_Seleccion_noLabel',
        point: {
          radius: 5,
          fill: {
            color: '#88ff00',
            opacity: 0.5
          },
          stroke: {
            color: '#88ff00',
          }
        },
        polygon: {
          fill: {
            color: '#88ff00',
            opacity: 0,
          },
          stroke: {
            color: '#88ff00',
            width: 4
          }
        }
      });

      this.styleNoDato = new M.style.Generic({
        name: 'Estilo_Seleccion',
        point: {
          radius: 5,
          fill: {
            color: '#88ff00',
            opacity: 0.5
          },
          stroke: {
            color: '#88ff00',
          }
        },
        polygon: {
          fill: {
            color: '#88ff00',
            opacity: 0,
          },
          stroke: {
            color: '#88ff00',
            width: 4
          },
          label: {
            text: 'Secreto \n estadístico',           // Texto etiqueta. fijo|función|atributo
            font: 'bold 16px Courier New',  // Fuente de la etiqueta
            scale: 0.8,                     // Escala de la etiqueta
            offset: [0, 0],                // Desplazamiento en píxeles
            color: '#000',                  // Color del texto
            // Halo del texto
            stroke: {
              color: '#FFF',       // Color del halo
              width: 5,            // Grosor del halo
              //linedash: [5, 5, 20],  // Patrón de distancias
              linedashoffset: 1,   // Offset de fase
              linecap: 'round',   // Estilo de final de linea. round|square|butt
              linejoin: 'round',   // Estilo de conexión de segmentos. miter|round|bevel
              miterlimit: 15       // Tamaño máximo segmento de conexión
            },
            rotate: false,                 // Rotación con dispositivo
            rotation: 0,                 // Rotación de la etiqueta
            align: M.style.align.CENTER,    // Alineación horizontal. CENTER|LEFT|RIGHT
            baseline: M.style.baseline.MIDDLE, // Alineación vertical. TOP|BOTTOM|MIDDLE          
          }
        }
      });

      this.CursorAddElement = 'data:image/svg+xml;base64,DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmVyc2lvbj0iMS4wIiB3aWR0aD0iMzAuMDAwMDAwIiBoZWlnaHQ9IjMwLjAwMDAwMCIgdmlld0JveD0iLTEgLTEgMzYgMzYiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPg0KDQo8ZyB0cmFuc2Zvcm09InNjYWxlKDAuMDYwMDAsIDAuMDYwMDApIiBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMjAiPg0KPHBhdGggZD0iTSAxMi41MCw2Ljc1DQogICAgICAgICAgIEMgMjkuMzMsLTUuMzMgNDIuMjUsMi4yNSA0Mi4yNSwyLjI1DQogICAgICAgICAgICAgNDIuMjUsMi4yNSA0OTAuMDAsMTg5Ljc1IDQ5MC4wMCwxODkuNzUNCiAgICAgICAgICAgICA0OTAuMDAsMTg5Ljc1IDUwOC4wMCwxOTUuNjcgNTA4LjAwLDIxNy4zMw0KICAgICAgICAgICAgIDUwNS4zMywyMzguNjcgNDg1LjAwLDI0Mi41MCA0ODUuMDAsMjQyLjUwDQogICAgICAgICAgICAgNDg1LjAwLDI0Mi41MCAzMTAuNTAsMzEwLjc1IDMxMC41MCwzMTAuNzUNCiAgICAgICAgICAgICAzMTAuNTAsMzEwLjc1IDMwNy41MCwzMTIuMjUgMzAyLjc1LDMxNy41Ng0KICAgICAgICAgICAgIDI5OS4wNiwzMjIuNzUgMjk3Ljc1LDMyNy4wMCAyOTcuNzUsMzI3LjAwDQogICAgICAgICAgICAgMjk3Ljc1LDMyNy4wMCAyMjIuMjUsNDk4LjI1IDIyMi4yNSw0OTguMjUNCiAgICAgICAgICAgICAyMjIuMjUsNDk4LjI1IDIxNC41MCw1MTMuMDAgMTk3LjY3LDUxMy4wMA0KICAgICAgICAgICAgIDE4Mi4wMCw1MTQuMDAgMTc0LjAwLDQ5Ny41MCAxNzQuMDAsNDk3LjUwDQogICAgICAgICAgICAgMTc0LjAwLDQ5Ny41MCA1LjUwLDM2LjAwIDUuNTAsMzYuMDANCiAgICAgICAgICAgICA1LjUwLDM2LjAwIC0xLjAwLDE4LjUwIDEyLjUwLDYuNzUgWiIvPg0KDQogICAgICAgICAgICAgPGxpbmUgeDE9IjE2MCIgeTE9IjIzMiIgeDI9IjMxMCIgeTI9IjIzMiIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjMwIi8+DQogICAgICAgICAgICAgPGxpbmUgeDE9IjIzNSIgeTE9IjE1NyIgeDI9IjIzNSIgeTI9IjMwNyIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjMwIi8+DQo8IS0tIDxwYXRoIGQ9Ik00OTIgMTkxIHEgNTU4IDIxNSA0OTIgMjQwIEwzMTUgMzA5IEwgMzA2IDMxNSBMIDI5OSAzMjYgTCAyMjQgNDk1IEwgMTk5IDUxMiBMIDE3MyA0OTUgTCA0IDMzIEwgMTEgMTAgTCAzNSAwWiIvPiAtLT4NCjwvZz4NCjwvc3ZnPg==';

      this.CursorRemoveElement = 'data:image/svg+xml;base64,DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmVyc2lvbj0iMS4wIiB3aWR0aD0iMzAuMDAwMDAwIiBoZWlnaHQ9IjMwLjAwMDAwMCIgdmlld0JveD0iLTEgLTEgMzYgMzYiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPg0KDQo8ZyB0cmFuc2Zvcm09InNjYWxlKDAuMDYwMDAsIDAuMDYwMDApIiBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMjAiPg0KPHBhdGggZD0iTSAxMi41MCw2Ljc1DQogICAgICAgICAgIEMgMjkuMzMsLTUuMzMgNDIuMjUsMi4yNSA0Mi4yNSwyLjI1DQogICAgICAgICAgICAgNDIuMjUsMi4yNSA0OTAuMDAsMTg5Ljc1IDQ5MC4wMCwxODkuNzUNCiAgICAgICAgICAgICA0OTAuMDAsMTg5Ljc1IDUwOC4wMCwxOTUuNjcgNTA4LjAwLDIxNy4zMw0KICAgICAgICAgICAgIDUwNS4zMywyMzguNjcgNDg1LjAwLDI0Mi41MCA0ODUuMDAsMjQyLjUwDQogICAgICAgICAgICAgNDg1LjAwLDI0Mi41MCAzMTAuNTAsMzEwLjc1IDMxMC41MCwzMTAuNzUNCiAgICAgICAgICAgICAzMTAuNTAsMzEwLjc1IDMwNy41MCwzMTIuMjUgMzAyLjc1LDMxNy41Ng0KICAgICAgICAgICAgIDI5OS4wNiwzMjIuNzUgMjk3Ljc1LDMyNy4wMCAyOTcuNzUsMzI3LjAwDQogICAgICAgICAgICAgMjk3Ljc1LDMyNy4wMCAyMjIuMjUsNDk4LjI1IDIyMi4yNSw0OTguMjUNCiAgICAgICAgICAgICAyMjIuMjUsNDk4LjI1IDIxNC41MCw1MTMuMDAgMTk3LjY3LDUxMy4wMA0KICAgICAgICAgICAgIDE4Mi4wMCw1MTQuMDAgMTc0LjAwLDQ5Ny41MCAxNzQuMDAsNDk3LjUwDQogICAgICAgICAgICAgMTc0LjAwLDQ5Ny41MCA1LjUwLDM2LjAwIDUuNTAsMzYuMDANCiAgICAgICAgICAgICA1LjUwLDM2LjAwIC0xLjAwLDE4LjUwIDEyLjUwLDYuNzUgWiIvPg0KDQogICAgICAgICAgICAgPGxpbmUgeDE9IjE2MCIgeTE9IjIzMiIgeDI9IjMxMCIgeTI9IjIzMiIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjMwIi8+DQogICAgICAgICAgICAgPCEtLSA8bGluZSB4MT0iMjM1IiB5MT0iMTU3IiB4Mj0iMjM1IiB5Mj0iMzA3IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMzAiLz4gLS0+DQo8IS0tIDxwYXRoIGQ9Ik00OTIgMTkxIHEgNTU4IDIxNSA0OTIgMjQwIEwzMTUgMzA5IEwgMzA2IDMxNSBMIDI5OSAzMjYgTCAyMjQgNDk1IEwgMTk5IDUxMiBMIDE3MyA0OTUgTCA0IDMzIEwgMTEgMTAgTCAzNSAwWiIvPiAtLT4NCjwvZz4NCjwvc3ZnPg==';

      this.CursorAddElementByPolygon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMCIgd2lkdGg9IjMwLjAwMDAwMCIgaGVpZ2h0PSIzMC4wMDAwMDAiIHZpZXdCb3g9Ii0xIC0xIDM2IDM2IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Ij4KCjxnIHRyYW5zZm9ybT0ic2NhbGUoMC4wNjAwMCwgMC4wNjAwMCkiIGZpbGw9IiNGRkZGRkYiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyMCI+CjxwYXRoIGQ9Ik0gMTIuNTAsNi43NQogICAgICAgICAgIEMgMjkuMzMsLTUuMzMgNDIuMjUsMi4yNSA0Mi4yNSwyLjI1CiAgICAgICAgICAgICA0Mi4yNSwyLjI1IDQ5MC4wMCwxODkuNzUgNDkwLjAwLDE4OS43NQogICAgICAgICAgICAgNDkwLjAwLDE4OS43NSA1MDguMDAsMTk1LjY3IDUwOC4wMCwyMTcuMzMKICAgICAgICAgICAgIDUwNS4zMywyMzguNjcgNDg1LjAwLDI0Mi41MCA0ODUuMDAsMjQyLjUwCiAgICAgICAgICAgICA0ODUuMDAsMjQyLjUwIDMxMC41MCwzMTAuNzUgMzEwLjUwLDMxMC43NQogICAgICAgICAgICAgMzEwLjUwLDMxMC43NSAzMDcuNTAsMzEyLjI1IDMwMi43NSwzMTcuNTYKICAgICAgICAgICAgIDI5OS4wNiwzMjIuNzUgMjk3Ljc1LDMyNy4wMCAyOTcuNzUsMzI3LjAwCiAgICAgICAgICAgICAyOTcuNzUsMzI3LjAwIDIyMi4yNSw0OTguMjUgMjIyLjI1LDQ5OC4yNQogICAgICAgICAgICAgMjIyLjI1LDQ5OC4yNSAyMTQuNTAsNTEzLjAwIDE5Ny42Nyw1MTMuMDAKICAgICAgICAgICAgIDE4Mi4wMCw1MTQuMDAgMTc0LjAwLDQ5Ny41MCAxNzQuMDAsNDk3LjUwCiAgICAgICAgICAgICAxNzQuMDAsNDk3LjUwIDUuNTAsMzYuMDAgNS41MCwzNi4wMAogICAgICAgICAgICAgNS41MCwzNi4wMCAtMS4wMCwxOC41MCAxMi41MCw2Ljc1IFoiLz4KCiAgICAgICAgICAgICA8cG9seWdvbiBwb2ludHM9IjE0MCwyMzIgMjA1LDExNyAzNDAsMjEyIDIwNSwzNjciIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIzMCIvPgogICAgICAgICAgICAgCjwvZz4KPC9zdmc+';

      this.SeleccionGrid_layer.setStyle(this.estiloSeleccionGrid);

      this.map_.addLayers(this.SeleccionGrid_layer);

      this.addToponymy();

      this.addYear();
      this.addMenus();

      this.addEvents(html);

      this.getMuniProv();

      success(html);
    });
  }



  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {
    // calls super to manage de/activation
    super.activate();
  }
  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */
  deactivate() {
    // calls super to manage de/activation
    super.deactivate();

  }
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-managegrid button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof ManagegridControl;
  }

  // Add your own functions

  addEvents(html) {
    this.grupos = html.querySelectorAll('div.GroupGrid');
    this.subGrupos = html.querySelectorAll('div.subGroupGrid');
    this.pest_divMenus = html.querySelectorAll('label#pest_divMenus')[0];
    this.pest_divBusqueda = html.querySelectorAll('label#pest_divBusqueda')[0];
    this.toponimiaOnOff = html.querySelectorAll('input#toponimiaOnOff')[0];

    this.transparencyControl = html.querySelectorAll('input#transparencyControl')[0];

    this.identLayerCharged = html.querySelectorAll('div#identLayerCharged')[0];
    this.selectMunicipios = html.querySelectorAll('select#selectMunicipios')[0];
    this.selectProvincias = html.querySelectorAll('select#selectProvincias')[0];

    this.selectGrid = html.querySelectorAll('div#selectGrid')[0];

    this.selectGridButton = html.querySelectorAll('button#selectGridButton')[0];
    this.selectGridButtonByPolygon = html.querySelectorAll('button#selectGridButtonByPolygon')[0];
    this.deleteGridButton = html.querySelectorAll('button#deleteGridButton')[0];
    this.downLoadGridButton = html.querySelectorAll('button#downLoadGridButton')[0];
    this.resultSumatorio = html.querySelectorAll('div#resultSumatorio')[0];
    this.tableSumatorio = html.querySelectorAll('table#tableSumatorio')[0];

    this.loadButton = html.querySelectorAll('button#loadButton')[0];
    this.clearButton = html.querySelectorAll('button#clearButton')[0];

    this.controlGetInfo;



    this.pest_divMenus.addEventListener('click', () => {
      if (!this.pest_divMenus.classList.contains('actived')) {
        this.divBusqueda.style.display = 'none';
        this.divCapas.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divMenus.classList.toggle('pest_legend');
        this.pest_divMenus.classList.toggle('actived');
      }
    });

    this.pest_divBusqueda.addEventListener('click', () => {
      if (!this.pest_divBusqueda.classList.contains('actived')) {
        this.divCapas.style.display = 'none';
        this.divBusqueda.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divBusqueda.classList.toggle('pest_legend');
        this.pest_divBusqueda.classList.toggle('actived');
      }
    });

    this.selectYear.addEventListener('change', () => {

      if (document.querySelectorAll('div.layerSelected').length != 0) {
        var previousLayerLegend = document.querySelectorAll('div.layerSelected')[0].children[0].innerHTML;
        let nextLayerToCharge = this.findLayerByYear(previousLayerLegend, this.selectYear.value);

        if (this.map_.getPopups() != null) {
          this.map_.removePopup();
        }

        this.removeGridLayers();

        this.addMenus();
        this.addEventsMenus();

        if (nextLayerToCharge) {
          setTimeout(() => {
            this.selectLayer(nextLayerToCharge);
          }, 10);
        } else {
          if (this.divLeyenda.style.display == 'block') {
            this.divMenus.style.height = '';
            setTimeout(() => {
              this.divLeyenda.style.display = 'none';
              this.divLeyenda.innerHTML = '';
            }, 500);
          }
          if (this.divOpacityRange.style.display == 'block') {
            this.divOpacityRange.style.display = 'none';
          }

          this.identLayerCharged.innerHTML = '';
          M.dialog.info('El año ' + this.selectYear.value + ' no dispone de los datos referentes a ' + previousLayerLegend + '<br>Seleccione otro año u otra capa para el año ' + this.selectYear.value, 'AVISO');
        }
      } else {
        this.addMenus();
        this.addEventsMenus();
      }

    });

    this.toponimiaOnOff.addEventListener('change', () => {
      if (this.toponimiaOnOff.checked) {
        this.toponimiaOnOff.parentNode.title = 'Desactiva la toponimia en el visor';
        this.map_.getLayers({ name: this.initialParameters.toponymy.name })[0].setVisible(true);
      } else {
        this.toponimiaOnOff.parentNode.title = 'Activa la toponimia en el visor';
        this.map_.getLayers({ name: this.initialParameters.toponymy.name })[0].setVisible(false);
      }

    });

    this.transparencyControl.addEventListener('change', () => {

      this.changeOpacity(this.transparencyControl.value);
      this.transparencyControl.title = 'transparencia ' + this.transparencyControl.value * 100 + '%';

    });

    this.clearButton.addEventListener('click', () => {
      if (document.querySelectorAll('div#divDownload').length != 0) {
        document.querySelectorAll('div#divDownload')[0].remove();
      }

      if (document.querySelectorAll('div#okDownload').length != 0) {
        document.querySelectorAll('div#okDownload')[0].remove();
      }

      this.choices_selectMunicipios.removeActiveItems();
      this.choices_selectProvincias.removeActiveItems();

      this.choices_selectMunicipios.clearChoices();
      this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());

      if (this.map_.getGeoJSON({ name: "Capa Seleccion de Elementos" }).length != 0) {
        this.map_.removeLayers(this.map_.getGeoJSON({ name: "Capa Seleccion de Elementos" }));
      }

      this.choices_selectProvincias.enable();
      this.choices_selectMunicipios.enable();

    });

    this.loadButton.addEventListener('click', () => {

      if (document.querySelectorAll('div#divDownload').length == 0) {

        // if (!this.choices_selectMunicipios.input.isDisabled && !this.choices_selectProvincias.input.isDisabled) {
        let selectedMunicipios = this.choices_selectMunicipios.getValue(true);
        let selectedProvincias = this.choices_selectProvincias.getValue(true);

        this.choices_selectProvincias.disable();
        this.choices_selectMunicipios.disable();

        if (this.layerToCharge) {
          if (selectedMunicipios.length || selectedProvincias.length) {
            this.getZona(selectedMunicipios, selectedProvincias);
            this.buildArrayQuery(selectedMunicipios, selectedProvincias);
          } else {
            M.dialog.info('Seleccione Provincia o Municipio sobre los que realizar la búsqueda', 'AVISO');
            this.choices_selectProvincias.enable();
            this.choices_selectMunicipios.enable();
          }
        } else {
          if (selectedMunicipios.length || selectedProvincias.length) {
            M.dialog.info('Seleccione Capa sobre la que realizar la búsqueda en la pestaña <b>Seleccíon Capas</b>', 'AVISO');
          } else {
            M.dialog.info('Seleccione Capa sobre la que realizar la búsqueda en la pestaña <b>Seleccíon Capas</b> <br> Seleccione Provincia o Municipio sobre los que realizar la búsqueda', 'AVISO');
          }
          this.choices_selectProvincias.enable();
          this.choices_selectMunicipios.enable();
        }


      } else {
        M.dialog.info('Debe limpiar los campos seleccionados pulsando el botón <b>Limpiar</b> para una nueva búsqueda', 'AVISO');
      }

    });

    this.selectGridButton.addEventListener('click', () => {
      this.selectGridButton.classList.toggle('selectGridActived');

      if (!this.layerToCharge) {
        M.dialog.info('Debe seleccionar una capa en la pestaña <b>Selecci&oacute;n capas</b> para selecconar elementos de la misma', 'AVISO');
        document.querySelectorAll('div.m-dialog button')[0].addEventListener('click', () => {
          this.selectGridButton.classList.remove('selectGridActived');
          document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'unset';
        });

      }

      if (this.selectGridButton.classList.contains('selectGridActived')) {
        if (this.selectGridButtonByPolygon.classList.contains('selectGridByPolygonActived')) {
          this.selectGridButtonByPolygon.click();
        }
        this.selectGridButton.title = this.selectGridButton.title.replace('Activa', 'Desactiva');
        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorAddElement + ')1 1, pointer';
        if (this.controlGetInfo.activated) {
          this.controlGetFeatureInfoActivated = true;
          this.controlGetInfo.activationBtn_.click();
        }

      } else {
        this.selectGridButton.title = this.selectGridButton.title.replace('Desactiva', 'Activa');
        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'unset';
        if (this.controlGetFeatureInfoActivated) {
          if (!this.controlGetInfo.activated) {
            this.controlGetInfo.activationBtn_.click();
          }
          this.controlGetFeatureInfoActivated = false;
        }
      }
    });

    this.selectGridButtonByPolygon.addEventListener('click', () => {
      this.selectGridButtonByPolygon.classList.toggle('selectGridByPolygonActived');
      if (this.selectGridButtonByPolygon.classList.contains('selectGridByPolygonActived')) {
        if (this.map_.getScale() < 65000) {
          if (this.selectGridButton.classList.contains('selectGridActived')) {
            this.selectGridButton.click();
          }
          this.selectGridButtonByPolygon.title = this.selectGridButtonByPolygon.title.replace('Activa', 'Desactiva');
          if (this.controlGetInfo.activated) {
            this.controlGetFeatureInfoActivated = true;
            this.controlGetInfo.activationBtn_.click();
          }
          document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorAddElementByPolygon + ')1 1, pointer';
          this.drawSelectionPolygon();
        } else {
          M.dialog.info('Acerque el zoom hasta una escala superior a 1:65.000 para poder usar la herramienta de selección por polígono', 'AVISO');
          this.selectGridButtonByPolygon.classList.toggle('selectGridByPolygonActived');
        }
      } else {
        this.selectGridButtonByPolygon.title = this.selectGridButtonByPolygon.title.replace('Desactiva', 'Activa');
        if (this.controlGetFeatureInfoActivated) {
          if (!this.controlGetInfo.activated) {
            this.controlGetInfo.activationBtn_.click();
          }
          this.controlGetFeatureInfoActivated = false;
        }
        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'unset';
        this.map_.getMapImpl().removeInteraction(this.i_poligono);
        this.sourceLayer.clear();
      }
    });



    this.deleteGridButton.addEventListener('click', () => {
      this.deleteGridButton.classList.toggle('selectGridActived');
      this.numberItemSelected = 0;
      this.sumatorioGrid = 0;

      setTimeout(() => {
        this.SeleccionGrid_layer.removeFeatures(this.SeleccionGrid_layer.getFeatures());
        this.tableSumatorio.querySelectorAll('td')[0].innerHTML = 0;
        this.tableSumatorio.querySelectorAll('td')[1].innerHTML = 0;
        this.tableSumatorio.querySelectorAll('td')[2].innerHTML = 0;
        this.deleteGridButton.classList.toggle('selectGridActived');
      }, 100);
    });

    this.downLoadGridButton.addEventListener('click', () => {
      let featuresToDownload = this.SeleccionGrid_layer.getFeatures().filter(obj => obj.style_ == null);
      if (featuresToDownload.length > 0) {
        this.downLoadGridButton.classList.toggle('selectGridActived');

        let result = {
          type: 'FeatureCollection',
          features: [],
          crs: {
            properties: { name: 'urn:ogc:def:crs:' + this.map_.getProjection().code },
            type: 'name'
          }
        };

        featuresToDownload.forEach((feature) => {
          result.features.push(feature.getGeoJSON());
        });

        //  Si hay un filtro para las propiedades a exportar se aplica 

        if (this.layerToCharge.filterProperties) {
          result.features.forEach((feature) => {
            Object.entries(feature.properties).forEach(([key, value]) => {
              if (!this.layerToCharge.filterProperties.includes(key)) {
                delete feature.properties[key];
              }
            });
          });
        }


        this.downloadCSV({ filename: this.layerToCharge.style + "_Seleccion.csv", data: result });
      }

    });

    this.map_.on(M.evt.CLICK, (evt) => {
      if (this.selectGridButton.classList.contains('selectGridActived')) {
        this.getDataWMS(evt);
      }
    });

    this.map_.on(M.evt.CHANGE_ZOOM, () => {
      if (this.SeleccionGrid_layer.getStyle().getOptions().name == 'Estilo_Seleccion' && this.map_.getScale() > 30000) {
        this.SeleccionGrid_layer.setStyle(this.estiloSeleccionGrid_NoLabel);
      }
      if (this.SeleccionGrid_layer.getStyle().getOptions().name == 'Estilo_Seleccion_noLabel' && this.map_.getScale() <= 30000) {
        this.SeleccionGrid_layer.setStyle(this.estiloSeleccionGrid);
      }
      if ((this.map_.getScale() > 65000) && (this.selectGridButtonByPolygon.classList.contains('selectGridByPolygonActived'))) {
        M.dialog.info('Se ha desactivado la herramienta de selección por polígono porque ha cambiado la escala de visualización a una inferior a 1:65.000.<br>La herramienta solamente está disponible para escalas superiores a 1:65.000.', 'AVISO');
        this.selectGridButtonByPolygon.classList.remove('selectGridByPolygonActived');
        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'unset';
        this.map_.getMapImpl().removeInteraction(this.i_poligono);
        this.sourceLayer.clear();
      }
    });

    this.map_.on(M.evt.COMPLETED, () => {
      this.controlGetInfo = this.map_.getControls({ name: 'getfeatureinfo' })[0] || this.map_.getControls({ name: 'GetFeatInf' })[0];

      this.controlGetInfo.on(M.evt.ACTIVATED, () => {
        if (this.selectGridButton.classList.contains('selectGridActived')) {
          M.dialog.info('Se ha desactivado la <b>selección de elementos</b> para poder activar la herramienta <b>Get Feature Info</b>', 'AVISO');
          this.selectGridButton.classList.remove('selectGridActived');
          document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'unset';

        }
      });
    });

    this.SeleccionGrid_layer.on(M.evt.SELECT_FEATURES, () => {
      if (this.selectGridButton.classList.contains('selectGridActived')) {
        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorAddElement + ')1 1, pointer';
      }
    });

    this.SeleccionGrid_layer.on(M.evt.HOVER_FEATURES, (evt) => {

      if (this.selectGridButton.classList.contains('selectGridActived')) {

        this.controlHoverFeatures[0] = evt[0].getImpl().getId();

        if (this.controlHoverFeatures[1] == false) {
          document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorRemoveElement + ')1 1, pointer';
        }

      } else if (this.selectGridButtonByPolygon.classList.contains('selectGridByPolygonActived')) {

        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorAddElementByPolygon + ')1 1, pointer';

      } else {
        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'default';
      }

    });

    this.SeleccionGrid_layer.on(M.evt.LEAVE_FEATURES, (evt) => {

      if (this.selectGridButton.classList.contains('selectGridActived')) {

        this.controlHoverFeatures[1] = evt[0].getImpl().getId();

        if (this.controlHoverFeatures[0] == this.controlHoverFeatures[1]) {
          this.controlHoverFeatures = [false, false];
          document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorAddElement + ')1 1, pointer';
        }

      }

    });

    this.addEventsMenus();

    // CHOICES

    this.choices_selectProvincias = new Choices(this.selectProvincias, { allowHTML: true, choices: [], closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Provincia', itemSelectText: 'Seleccione', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });

    this.choices_selectMunicipios = new Choices(this.selectMunicipios, { allowHTML: true, choices: [], closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Municipio', itemSelectText: 'Seleccione', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });

    this.selectProvincias.addEventListener('change', (evt) => {
      let prov = evt.detail.value;

      let listSelectedMun = this.choices_selectMunicipios.getValue(true);

      let listMunDeletedProv = this.listFullMunicipios.filter(obj => obj.provincia == prov)[0].municipios;

      //  Si en los municipios seleccionados está alguno que pertenece a la provincia eliminada se elimina de la selección de municipios

      listSelectedMun.forEach((muniSelected) => {
        if (listMunDeletedProv.filter(obj => obj.nombre == muniSelected).length != 0) {
          this.choices_selectMunicipios.removeActiveItemsByValue(muniSelected);
        }
      });

      this.choices_selectMunicipios.clearChoices();
      this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());
    });

    this.selectMunicipios.addEventListener('change', (evt) => {
      let mun = evt.detail.value;
      let prov;
      let selectecMunicipios = this.choices_selectMunicipios.getValue(true);
      for (let p of this.listFullMunicipios) {
        if (p.municipios.filter(obj => obj.nombre == mun).length != 0) {
          prov = p.provincia;
        }
      }

      if (selectecMunicipios.includes(mun)) {   // El municipio se ha añadido
        // si la provincia del municipio seleccionado no está seleccionada la selecciona automáticamente
        if (!this.choices_selectProvincias.getValue(true).includes(prov)) {
          this.choices_selectProvincias.setChoiceByValue(prov);
        }
      } else {    // El municipio se ha eliminado
        let checkeaProvincia = false;
        let listMuniByProvSelected = this.listFullMunicipios.filter(obj => obj.provincia == prov)[0].municipios;

        for (let m of selectecMunicipios) {
          if (listMuniByProvSelected.filter(obj => obj.nombre == m).length != 0) {
            checkeaProvincia = true;
          }
        }

        // si hay alguna provincia seleccionada sin ningún municipio seleccionado la elimina automáticamente
        if (!checkeaProvincia) {
          this.choices_selectProvincias.removeActiveItemsByValue(prov);
          this.choices_selectMunicipios.clearChoices();
          this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());
        }
      }

    });
  }

  addToponymy() {
    let toponimia = new M.layer.WMS({
      url: this.initialParameters.toponymy.url,
      name: this.initialParameters.toponymy.name,
      legend: this.initialParameters.toponymy.legend,
      transparent: this.initialParameters.toponymy.transparent,
      tiled: this.initialParameters.toponymy.tiled,
      version: this.initialParameters.toponymy.version
    }, {
      queryable: false
    });
    toponimia.setZIndex(2000);

    this.map_.addWMS(toponimia);
  }

  getZona(selectedMunicipios, selectedProvincias) {
    let zone;
    let urlZone;
    if (selectedMunicipios.length == 0) {
      zone = "('";
      selectedProvincias.forEach((provincia) => {
        zone += provincia + "','";
      });
      zone = zone.slice(0, -2);
      zone += ")";
      urlZone = 'https://www.ideandalucia.es/services/DERA_g13_limites_administrativos/wfs?service=WFS&version=2.0.0&request=GetFeature&typename=DERA_g13_limites_administrativos:g13_01_Provincia&propertyName=provincia,geom&outputFormat=application/json';
    } else {
      zone = "('";
      selectedMunicipios.forEach((municipio) => {
        zone += municipio + "','";
      });
      zone = zone.slice(0, -2);
      zone += ")";
      urlZone = 'https://www.ideandalucia.es/services/DERA_g13_limites_administrativos/wfs?service=WFS&version=2.0.0&request=GetFeature&typename=DERA_g13_limites_administrativos:g13_01_TerminoMunicipal&propertyName=nombre,geom&outputFormat=application/json';
    }

    // centramos el mapa en la zona buscada

    this.zoomToSearch(zone, urlZone);


  }

  buildArrayQuery(selectedMunicipios, selectedProvincias) {

    let codProv = new Array();
    let listMuni = new Array();

    selectedProvincias.forEach((provincia) => {
      codProv.push(this.listFullMunicipios.filter(obj => obj.provincia == provincia)[0].codProv);
    });

    let typename = this.layerToCharge.url.replace('/wms?', '').split('/');
    typename = typename[typename.length - 1] + ':' + this.layerToCharge.mainLayer;

    selectedMunicipios.forEach((municipio) => {

      listMuni.push(municipio);
      // eliminamos tildes y pasamos a mayusculas para incluirlo en la lista de busqueda
      listMuni.push(municipio.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase());

    });

    let filterProperties = '';
    let cql_filterProperties = '';
    if (this.layerToCharge.filterProperties) {
      if (typeof this.layerToCharge.filterProperties === 'object') {
        filterProperties = '&propertyname=';
        this.layerToCharge.filterProperties.forEach((propertie) => {
          filterProperties += propertie + ',';
        });
        filterProperties = filterProperties.slice(0, -1);
      } else {
        cql_filterProperties = this.layerToCharge.filterProperties;
      }

    }
    let query = this.layerToCharge.url.replace('/wms?', '/wfs?') + 'service=WFS&version=1.1.0&request=GetFeature&typename=' + typename + filterProperties + '&outputFormat=application/json&srsname=EPSG:25830&CQL_FILTER=';

    if (selectedMunicipios.length != 0) {
      if (this.layerToCharge.filterProperties) {
        if (typeof this.layerToCharge.filterProperties === 'object') {
          //  Array campos a recuperar
          listMuni.forEach((muni) => {
            query += this.initialParameters.municipioField + " LIKE '" + muni + "' OR " + this.initialParameters.municipioField + " LIKE '%/ " + muni + "' OR " + this.initialParameters.municipioField + " LIKE '" + muni + " /%' OR ";
          });
        } else {
          //sentencia SQL
          listMuni.forEach((muni) => {
            query += cql_filterProperties + " AND " + this.initialParameters.municipioField + " LIKE '%" + muni + "%' OR ";
          });
        }
      } else {
        // filterProperties es false
        listMuni.forEach((muni) => {
          query += this.initialParameters.municipioField + " LIKE '" + muni + "' OR " + this.initialParameters.municipioField + " LIKE '%/ " + muni + "' OR " + this.initialParameters.municipioField + " LIKE '" + muni + " /%' OR ";
        });
      }
      query = query.slice(0, -4);

    } else {
      codProv.forEach((cod) => {
        if (cql_filterProperties.length == 0) {
          query += this.initialParameters.codmunField + " LIKE '" + cod + "%' OR " + this.initialParameters.codmunField + " LIKE '%/ " + cod + "%' OR ";
        } else {
          query += cql_filterProperties + " AND " + this.initialParameters.codmunField + " LIKE '" + cod + "%' OR " + this.initialParameters.codmunField + " LIKE '%/ " + cod + "%' OR ";
        }

      });
      query = query.slice(0, -4);
    }

    this.createTextDownloading();


    M.remote.get(encodeURI(query)).then((res) => {
      if (res.xml == null) {
        let result = JSON.parse(res.text);
        if (result.features.length != 0) {
          document.querySelectorAll('div#divTextDownloading')[0].remove();
          this.createButtonDownload(result);
        } else {
          document.querySelectorAll('div#divTextDownloading')[0].getAnimations()[0].cancel();
          document.querySelectorAll('div#divTextDownloading')[0].children[0].innerHTML = 'Datos no encontrados en la zona de búsqueda <br> seleccione una nueva zona';
          this.choices_selectProvincias.enable();
          this.choices_selectMunicipios.enable();
          setTimeout(() => {
            document.querySelectorAll('div#divTextDownloading')[0].remove();
          }, 5000);
        }

      } else {
        document.querySelectorAll('div#divTextDownloading')[0].getAnimations()[0].cancel();
        document.querySelectorAll('div#divTextDownloading')[0].children[0].innerHTML = 'Error de Descarga';
        setTimeout(() => {
          document.querySelectorAll('div#divTextDownloading')[0].remove();
        }, 5000);

      }
    });
  }

  createTextDownloading() {
    let newDiv = document.createElement('div');
    newDiv.id = 'divTextDownloading';
    newDiv.innerHTML = '<p> Descargando datos </p>';
    let divContainer = document.querySelectorAll('div#searchOptions')[0];
    divContainer.appendChild(newDiv);
  }

  createButtonDownload(result) {
    let newDiv = document.createElement('div');
    newDiv.id = 'divDownload';
    newDiv.innerHTML = '<button id="downloadData" title="Descarga los datos encontrados en formato .CSV">\n<i class="g-cartografia-descargar"></i>\n &nbsp;&nbsp;Descarga de datos encontrados</button>'
    let divContainer = document.querySelectorAll('div#searchOptions')[0];
    divContainer.appendChild(newDiv);

    document.querySelectorAll('button#downloadData')[0].addEventListener('click', () => {
      this.downloadCSV({ filename: this.layerToCharge.style + "_" + this.selectYear.value + ".csv", data: result });
    });

  }


  zoomToSearch(zone, urlZone) {
    if (urlZone.includes('g13_01_TerminoMunicipal')) {
      urlZone += '&CQL_FILTER= nombre IN ' + zone;
    } else {
      urlZone += '&CQL_FILTER= provincia IN ' + zone;
    }

    M.remote.get(encodeURI(urlZone)).then((res) => {
      let geometries = JSON.parse(res.text).features;

      //  ESTILO DE ELEMENTO RESALTADO

      let style_select_feature_table = new M.style.Polygon({
        stroke: {
          color: '#007932',
          width: 6
        }
      });

      //  CAPA SELECCION DE ELEMENTOS

      let SeleccionElementos_layer = new M.layer.GeoJSON({
        name: 'Capa Seleccion de Elementos',
        source: {
          crs: {
            "type": "name",
            "properties": {
              "name": "urn:ogc:def:crs:EPSG::25830"
            }
          },
          features: geometries,
          type: "FeatureCollection"
        },
        extract: false
      });

      SeleccionElementos_layer.setStyle(style_select_feature_table);

      if (this.map_.getGeoJSON({ name: "Capa Seleccion de Elementos" }).length != 0) {
        this.map_.removeLayers(this.map_.getGeoJSON({ name: "Capa Seleccion de Elementos" }));
      }

      this.map_.addLayers(SeleccionElementos_layer);

      this.map_.getLayers({ name: 'Capa Seleccion de Elementos' })[0].calculateMaxExtent().then((obj) => {
        this.map_.setBbox(obj);
      });

    });
  }

  getMuniProv() {
    M.remote.get(encodeURI(this.urlMunicipios)).then((res) => {
      let listMunicipios = JSON.parse(res.text).features;

      listMunicipios.forEach((municipio) => {
        if (this.listFullMunicipios.filter(obj => obj.provincia == municipio.properties.provincia).length == 0) {
          let reg = {
            provincia: municipio.properties.provincia,
            codProv: municipio.properties.cod_mun.slice(0, 2),
            municipios: [{
              cod_mun: municipio.properties.cod_mun,
              nombre: municipio.properties.nombre
            }]
          }
          this.listFullMunicipios.push(reg);
        } else {
          let reg = {
            cod_mun: municipio.properties.cod_mun,
            nombre: municipio.properties.nombre
          };
          this.listFullMunicipios.filter(obj => obj.provincia == municipio.properties.provincia)[0].municipios.push(reg);
        }
      });
    }).then(() => {

      this.choices_selectProvincias.setChoices(this.createSelectOptionsProvincias());
      this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());

    });

  }

  createSelectOptionsProvincias() {
    let selectOptions = new Array();
    for (let prov of this.listFullMunicipios) {
      let option = {
        value: prov.provincia,
        label: prov.provincia,
        selected: false,
        disbled: false,
      }
      selectOptions.push(option);
    }
    return selectOptions;
  }

  createSelectOptionsMunicipios() {
    let selectOptions = new Array();
    if (this.choices_selectProvincias.getValue(true).length == 0) {
      for (let prov of this.listFullMunicipios) {
        for (let mun of prov.municipios) {
          let option = {
            value: mun.nombre,
            label: mun.nombre,
            selected: false,
            disbled: false
          }
          selectOptions.push(option);
        }
      }
    } else {
      for (let provSelected of this.choices_selectProvincias.getValue(true)) {
        let prov = this.listFullMunicipios.filter(obj => obj.provincia == provSelected)[0];
        for (let mun of prov.municipios) {
          let option = {
            value: mun.nombre,
            label: mun.nombre,
            selected: false,
            disbled: false
          }
          selectOptions.push(option);
        }
      }
    }
    return selectOptions;
  }

  addYear() {
    let arrayYear = new Array();
    let testYear = new Array();
    this.groupLayers.forEach((grupo) => {
      grupo.theme.forEach((year) => {
        if (!arrayYear.includes(year.year)) {
          arrayYear.push(year.year);
        }
      });
    });

    arrayYear.sort((a, b) => {
      if (a < b) return 1;
      if (a > b) return -1;
      return 0;
    });

    arrayYear.forEach(year => {
      this.selectYear.innerHTML += '<option value="' + year + '">' + year + '</option>\n';
    });

    // comprobamos que el año introducido en los parametros existe

    if (this.initialParameters.initialYear != null && this.initialParameters.initialStyle == null) {
      // si el valor initialYear es last localizamos el último año con datos
      if (this.initialParameters.initialYear == 'last') {
        let lastYear = 0;
        this.groupLayers.forEach((groupData) => {
          groupData.theme.forEach((listData) => {
            if (listData.year > lastYear) {
              lastYear = listData.year;
            }
          });
        });
        // asignamos el valor del último año con datos a initialYear para cargar el menu

        this.initialParameters.initialYear = lastYear;

      } else {
        this.groupLayers.forEach((groupData) => {
          if (groupData.theme.filter(obj => obj.year == this.initialParameters.initialYear).length != 0) {
            testYear = groupData.theme.filter(obj => obj.year == this.initialParameters.initialYear);
          }
        });


        if (testYear.length == 0) { //  si no existe buscamos el año más próximo
          let nearestYear = null;

          this.groupLayers.forEach((groupData) => {
            groupData.theme.forEach((group) => {
              if (nearestYear == null) {
                nearestYear = group.year;
              }

              if (Math.abs(group.year - parseInt(this.initialParameters.initialYear)) < Math.abs(nearestYear - parseInt(this.initialParameters.initialYear))) {
                nearestYear = group.year;
              }
            });
          });

          //  modificamos la url que aparece en el navegador para que se muestre con los parámetros correctos

          let urlWithParameters = new URL(window.location.href);
          let urlParameters = urlWithParameters.searchParams;
          urlParameters.set('year', nearestYear);
          history.pushState({}, "", urlWithParameters);
          M.dialog.error(' Se muestran los correspondientes al ' + nearestYear + ' por ser los más próximos', 'ERROR - El año ' + this.initialParameters.initialYear + ' no está entre los datos disponibles');

          this.initialParameters.initialYear = nearestYear.toString();
        }
      }


      this.preLoadYear();
    }

    // comprobamos que la capa para el año introducido en los parametros existe

    if (this.initialParameters.initialYear != null && this.initialParameters.initialStyle != null) {
      // si el valor initialYear es last localizamos el último año con datos
      if (this.initialParameters.initialYear == 'last') {
        let lastYear = 0;
        this.groupLayers.forEach((groupData) => {
          groupData.theme.forEach((listData) => {
            if (listData.year > lastYear) {
              if (this.checkLayerByYear(listData.year, this.initialParameters.initialStyle)) {
                lastYear = listData.year;
              }
            }
          });
        });
        // asignamos el valor del último año con datos a initialYear para cargar el menu

        this.initialParameters.initialYear = lastYear;

      }

      if (this.checkLayerByYear(this.initialParameters.initialYear, this.initialParameters.initialStyle)) {
        this.preLoadYear()
        this.preLoadLayer();
      } else {
        // Eliminamos el parámetro style de la url ya que no ha encontrado la capa
        let urlWithParameters = new URL(window.location.href);
        let urlParameters = urlWithParameters.searchParams;
        urlParameters.delete('style');
        history.pushState({}, "", urlWithParameters);
        this.groupLayers.forEach((groupData) => {
          if (groupData.theme.filter(obj => obj.year == this.initialParameters.initialYear).length != 0) {
            testYear = groupData.theme.filter(obj => obj.year == this.initialParameters.initialYear);
          }
        });
        if (testYear.length != 0) {
          this.preLoadYear();
        } else {
          urlWithParameters = new URL(window.location.href);
          urlParameters = urlWithParameters.searchParams;
          urlParameters.delete('year');
          history.pushState({}, "", urlWithParameters);
        }

        M.dialog.error('No se ha encontrado <b>' + this.initialParameters.initialStyle + '</b> para el año <b>' + this.initialParameters.initialYear + '</b>', 'ERROR - Dato no encontrado');
      }
    }

  }

  addMenus() {
    let menuData;
    let addMenus = '';
    let firsDivClass;


    this.groupLayers.forEach((groupData) => {
      firsDivClass = ' firstDiv';

      menuData = groupData.theme.filter(obj => obj.year == this.selectYear.value);

      if (menuData.length != 0) {
        menuData = menuData[0].data;

        addMenus += '<h2>' + groupData.nameTheme + ' (' + this.selectYear.value + ')</h2>';

        menuData.forEach(groupLayer => {
          let flatName = groupLayer.groupName.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '');

          addMenus += "<div id='" + flatName + "' class='GroupGrid'>\n<div class='divTitle" + firsDivClass + "'>\n<h3 id='title_" + flatName + "' class= 'groupClosed' title='Despliega las capas de " + groupLayer.groupName + "'>" + groupLayer.groupName + "</h3>\n</div>\n<div id='layers_" + flatName + "' class='layersGroupGrid oculta'>\n";

          addMenus += "</div>\n</div>\n"
          if (firsDivClass.length > 0) {
            firsDivClass = '';
          }
        });

        this.divMenus.innerHTML = addMenus;

      }

    });


    this.groupLayers.forEach((groupData) => {

      menuData = groupData.theme.filter(obj => obj.year == this.selectYear.value);

      if (menuData.length != 0) {
        menuData = menuData[0].data;

        menuData.forEach(groupLayer => {
          let addLayers = "";
          let createSubgroup = true;
          let nameSubGroup = false;
          groupLayer.layers.forEach(layer => {
            if (layer.group_2 && createSubgroup) {
              // crea inicio del subgrupo aqui
              let flatName = layer.group_2.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '');
              addLayers += "<div id='SubGroup_" + flatName + "' class='subGroupGrid'>\n<h4 id='title_" + flatName + "' class='subGroupClosed' title='Despliega la capas de " + layer.group_2 + "'>" + layer.group_2 + "</h4>\n<div id='layers_SubGroup_" + flatName + "' class='layersSubGroupGrid subGroupOculta'>";
              createSubgroup = false;
              nameSubGroup = layer.group_2;
            }
            if (nameSubGroup != layer.group_2) {
              // crea el cierra del subgrupo aqui
              addLayers += "\n</div>\n</div>";

              if (layer.group_2) {
                // crea inicio del subgrupo aqui
                nameSubGroup = layer.group_2;
                let flatName = layer.group_2.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '');
                addLayers += "<div id='SubGroup_" + flatName + "' class='subGroupGrid'>\n<h4 id='title_" + flatName + "' class='subGroupClosed' title='Despliega la capas de " + layer.group_2 + "'>" + layer.group_2 + "</h4>\n<div id='layers_SubGroup_" + flatName + "' class='layersSubGroupGrid subGroupOculta'>";
              } else {
                nameSubGroup = false;
              }
            }

            if (layer.group_2) {
              addLayers += "<div id='gridLayer_" + layer.style + "' class='gridLayer2'>\n<p title='Añade la capa " + layer.legend + " al mapa'>" + layer.legend + "</p>\n</div>\n"
            } else {
              addLayers += "<div id='gridLayer_" + layer.style + "' class='gridLayer'>\n<p title='Añade la capa " + layer.legend + " al mapa'>" + layer.legend + "</p>\n</div>\n";
            }

          });

          let flatName = groupLayer.groupName.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '');
          this.divMenus.querySelectorAll('div#layers_' + flatName)[0].innerHTML = addLayers;

        });
      }

    });
  }

  addEventsMenus() {

    //  FUNCIONALIDAD DESPLEGAR-OCULTAR LISTA CAPAS

    if (document.querySelectorAll('div.m-managegrid')[0].querySelectorAll('div.GroupGrid').length != 0) {
      this.grupos = document.querySelectorAll('div.m-managegrid')[0].querySelectorAll('div.GroupGrid');
    }

    if (document.querySelectorAll('div.m-managegrid')[0].querySelectorAll('div.subGroupGrid').length != 0) {
      this.subGrupos = document.querySelectorAll('div.m-managegrid')[0].querySelectorAll('div.subGroupGrid');
    }



    this.grupos.forEach(grupo => {
      grupo.addEventListener('click', (evt) => {
        if (evt.target.tagName == 'H3') {

          evt.target.classList.toggle('groupOpened');
          evt.target.classList.toggle('groupClosed');
          let itemsVisibles = document.querySelectorAll('.visible');

          if (itemsVisibles.length != 0) {

            if (evt.target.id != itemsVisibles[0].parentNode.children[0].children[0].id) {
              itemsVisibles[0].parentNode.children[0].children[0].title = itemsVisibles[0].parentNode.children[0].children[0].title.replace('Oculta', 'Despliega');
              itemsVisibles[0].parentNode.children[0].children[0].classList.toggle('groupOpened');
              itemsVisibles[0].parentNode.children[0].children[0].classList.toggle('groupClosed');
              itemsVisibles[0].classList.toggle('visible');
              itemsVisibles[0].classList.toggle('oculta');
            }
          }
          let id = "layers_";
          id += grupo.id;
          document.querySelectorAll('div#' + id)[0].classList.toggle('oculta');
          document.querySelectorAll('div#' + id)[0].classList.toggle('visible');

          if (document.querySelectorAll('div#' + id)[0].classList.contains('visible')) {
            evt.target.title = 'Oculta las capas de ' + grupo.children[0].children[0].innerHTML;
          } else {
            evt.target.title = 'Despliega las capas de ' + grupo.children[0].children[0].innerHTML;
          }
        }

        //  SI HACEMOS CLICK SOBRE EL NOMBRE DE LA CAPA SE SELECCIONA O SE DESELECCIONA EN EL MAPA

        if (evt.target.tagName == 'P') {

          // ELIMINAMOS LA CLASE TREESELECTED DE LOS GRUPOS DE CAPAS SELECCIONADOS ANTERIORMENTE
          let prevTreeSelected = document.querySelectorAll('.treeSelected');

          prevTreeSelected.forEach((elem) => {
            elem.classList.remove('treeSelected');
          });

          if (document.querySelectorAll('div#divDownload').length != 0) {
            document.querySelectorAll('div#divDownload')[0].remove();
          }


          if (!evt.target.parentNode.classList.contains('layerSelected')) {
            if (this.divLeyenda.style.display == 'none') {
              this.divLeyenda.style.display = 'block';
              let newHeight = this.divMenus.clientHeight - 310;
              this.divMenus.setAttribute("style", "height:" + newHeight + "px");
            }

            if (this.divOpacityRange.style.display == 'none') {
              this.divOpacityRange.style.display = 'block';
            }

            if (document.querySelectorAll('div.layerSelected').length != 0) {
              document.querySelectorAll('div.layerSelected')[0].firstElementChild.title = document.querySelectorAll('div.layerSelected')[0].firstElementChild.title.replace('Elimina', 'Añade');
              document.querySelectorAll('div.layerSelected')[0].classList.remove('layerSelected');
            }

            evt.target.parentNode.classList.add('layerSelected');
            evt.target.title = evt.target.title.replace('Añade', 'Elimina');

            if (evt.target.parentNode.classList.contains('gridLayer')) {
              // AÑADIMOS LA CLASE TREESELECTED PARA RESALTAR EN VERDE LOS GRUPOS DE CAPAS SELECCIONADOS
              evt.target.parentNode.parentNode.parentNode.firstElementChild.classList.add('treeSelected');

              this.groupLayers.forEach((groupData) => {
                if (groupData.theme.filter(obj => obj.year == this.selectYear.value).length != 0) {
                  let recoverLayer = groupData.theme.filter(obj => obj.year == this.selectYear.value)[0].data.filter(obj => obj.groupName.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '') == evt.target.parentNode.parentNode.parentNode.id);

                  if (recoverLayer.length != 0) {
                    this.layerToCharge = recoverLayer[0].layers.filter(obj => obj.style == evt.target.parentNode.id.replace('gridLayer_', ''))[0];
                  }
                }

              });


              this.addGridLayers();
            } else {
              // AÑADIMOS LA CLASE TREESELECTED PARA RESALTAR EN VERDE LOS GRUPOS DE CAPAS SELECCIONADOS
              evt.target.parentNode.parentNode.parentNode.firstElementChild.classList.add('treeSelected');
              evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.firstElementChild.classList.add('treeSelected');

              this.groupLayers.forEach((groupData) => {
                let recoverLayer = groupData.theme.filter(obj => obj.year == this.selectYear.value);
                if (recoverLayer.length != 0) {
                  recoverLayer = recoverLayer[0].data.filter(obj => obj.groupName.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '') == evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.id);
                  if (recoverLayer.length != 0) {
                    recoverLayer = recoverLayer[0].layers.filter(obj => obj.style == evt.target.parentNode.id.replace('gridLayer_', ''));
                    if (recoverLayer.length != 0) {
                      this.layerToCharge = recoverLayer[0];
                    }
                  }
                }
              });

              this.addGridLayers();
            }
          } else {
            evt.target.parentNode.classList.remove('layerSelected');
            evt.target.title = evt.target.title.replace('Elimina', 'Añade');
            if (this.divLeyenda.style.display == 'block') {
              this.divMenus.style.height = '';
              setTimeout(() => {
                this.divLeyenda.style.display = 'none';
              }, 500);
            }
            if (this.divOpacityRange.style.display == 'block') {
              this.divOpacityRange.style.display = 'none';
            }

            this.layerToCharge = false;
            this.removeGridLayers();
            this.identLayerCharged.innerHTML = '';
          }
        }
      });
    });

    this.subGrupos.forEach(subGrupo => {
      subGrupo.addEventListener('click', (evt) => {
        if (evt.target.tagName == 'H4') {

          evt.target.classList.toggle('subGroupOpened');
          evt.target.classList.toggle('subGroupClosed');
          let itemsVisibles = document.querySelectorAll('.subGroupVisible');
          if (itemsVisibles.length != 0) {
            if (!itemsVisibles[0].id.includes(subGrupo.id)) {
              itemsVisibles[0].parentNode.children[0].title = itemsVisibles[0].parentNode.children[0].title.replace('Oculta', 'Despliega');
              itemsVisibles[0].parentNode.children[0].classList.toggle('subGroupOpened');
              itemsVisibles[0].parentNode.children[0].classList.toggle('subGroupClosed');
              itemsVisibles[0].classList.toggle('subGroupVisible');
              itemsVisibles[0].classList.toggle('subGroupOculta');
            }
          }
          let id = "layers_";
          id += subGrupo.id;
          document.querySelectorAll('div#' + id)[0].classList.toggle('subGroupOculta');
          document.querySelectorAll('div#' + id)[0].classList.toggle('subGroupVisible');

          if (document.querySelectorAll('div#' + id)[0].classList.contains('subGroupVisible')) {
            evt.target.title = 'Oculta las capas de ' + subGrupo.children[0].innerHTML;
          } else {
            evt.target.title = 'Despliega las capas de ' + subGrupo.children[0].innerHTML;
          }
        }
      });

    });

  }

  addGridLayers() {

    this.removeGridLayers();

    this.identLayerCharged.innerHTML = '<h3>' + this.layerToCharge.legend + ' (' + this.selectYear.value + ')</h3>';

    if (this.map_.getPopups() != null) {
      this.map_.removePopup();
    }

    let layer = new M.layer.WMS({
      url: this.layerToCharge.url,
      name: this.layerToCharge.mainLayer,
      legend: this.layerToCharge.legend,
      transparent: this.layerToCharge.transparent,
      tiled: this.layerToCharge.tiled,
      version: '1.3.0',
      styles: this.layerToCharge.style
    });

    if (this.layerToCharge.transparency) {
      this.transparencyControl.value = this.layerToCharge.transparency;
      this.transparencyControl.title = 'transparencia ' + this.transparencyControl.value * 100 + '%';
    } else {
      this.transparencyControl.value = 1;
      this.transparencyControl.title = 'transparencia 100%';
    }



    layer.on(M.evt.LOAD, () => {
      let legendImg = this.layerToCharge.url + 'SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=' + this.layerToCharge.mainLayer + '&STYLE=' + this.layerToCharge.style + '&FORMAT=image/png&EXCEPTIONS=image/png';
      this.addLegend(legendImg);
      layer.setOpacity(parseFloat(this.transparencyControl.value));

      //  recuperamos el estilo de representacion de la capa      

      let style = layer.styles;

      let url = layer.getImpl().url;

      let name = layer.getImpl().name;

      let urlGeometryName = this.layerToCharge.url.replace('/wms?', '/wfs?') + 'SERVICE=WFS&VERSION=1.1.0&REQUEST=DescribeFeatureType&typeName=' + name;


      M.remote.get(encodeURI(urlGeometryName)).then((res) => {
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(res.text, "text/xml");
        this.geometryFieldName = Array.from(xmlDoc.getElementsByTagName('xsd:element')).filter(obj => obj.getAttribute('type').includes('gml'))[0].getAttribute('name');
      });



      this.SeleccionGrid_layer.removeFeatures(this.SeleccionGrid_layer.getFeatures());

      M.remote.get(url + 'service=WMS&version=1.1.1&layers=' + name + '&request=GetStyles').then((res) => {
        if (res.code == 200) {
          var parser = new DOMParser();
          var xmlDoc = parser.parseFromString(res.text, "text/xml");

          //  obtenemos el campo que se representa en el servicio WMS

          this.mainVar = Array.from(xmlDoc.getElementsByTagName('sld:NamedLayer')[0].getElementsByTagName('sld:UserStyle')).filter(obj => obj.children[0].innerHTML == style)[0].getElementsByTagName('ogc:PropertyName')[0].innerHTML;

          //  actualizamos el campo que tiene que etiquetar
          //  solo se etiquetan los elementos de tipo poligonal          

          this.estiloSeleccionGrid.impl_.options_.polygon.label.text = "{{" + this.mainVar + "}}";

          this.tableSumatorio.querySelectorAll('tr')[0].children[0].innerHTML = this.layerToCharge.legend;
          this.sumatorioGrid = 0;
          this.numberItemSelected = 0;
          this.tableSumatorio.querySelectorAll('td')[0].innerHTML = 0;
          this.tableSumatorio.querySelectorAll('td')[1].innerHTML = 0;
          this.tableSumatorio.querySelectorAll('td')[2].innerHTML = 0;

        }
      });

      if (this.layerToCharge.sumationTool) {
        this.selectGrid.style.visibility = 'visible';
        this.tableSumatorio.querySelectorAll('tr')[1].style.display = '';
        this.tableSumatorio.querySelectorAll('tr')[2].style.display = '';
      } else {
        // this.selectGrid.style.visibility = 'hidden';
        this.selectGrid.style.visibility = 'visible';
        this.tableSumatorio.querySelectorAll('tr')[0].children[0].innerHTML = this.layerToCharge.legend;
        this.tableSumatorio.querySelectorAll('tr')[1].style.display = 'none';
        this.tableSumatorio.querySelectorAll('tr')[2].style.display = 'none';
        // if (this.selectGridButton.classList.contains('selectGridActived')) {
        //   this.selectGridButton.classList.remove('selectGridActived');
        //   document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'unset';
        // }
      }





    });
    this.map_.addWMS(layer);
  }

  removeGridLayers() {

    this.selectGrid.style.visibility = 'hidden';

    //  filtramos para que no elimine ni la capa de toponimia ni la de portales y viales

    let previousLayer = this.map_.getWMS().filter(obj => obj.wmcParent_ == null).filter(obj => obj.impl_.transparent != false).filter(obj => obj.impl_.name != 'CDAU_wms').filter(obj => obj.impl_.name != this.initialParameters.toponymy.name);


    if (previousLayer.length != 0) {
      this.map_.removeLayers(previousLayer);
    } else {
      this.transparencyControl.value = 1;
    }

  }

  addLegend(legendImg) {
    if (this.layerToCharge.group_2) {
      this.divLeyenda.innerHTML = '<div id="divLegendTitle">\n<div>\n<h3 class="titleGroupLegend">' + this.layerToCharge.group_2 + '</h3>\n<h4 class="titleLegend">' + this.layerToCharge.legend + ' (' + this.selectYear.value + ')' + '</h4>\n</div>\n</div>\n';
    } else {
      this.divLeyenda.innerHTML = '<div id="divLegendTitle">\n<h3 class="titleLegend">' + this.layerToCharge.legend + ' (' + this.selectYear.value + ')' + '</h3>\n</div>\n';
    }

    this.divLeyenda.innerHTML += '<div class="imgLegend">\n<img src="' + legendImg + '" alt="Leyenda de ' + this.layerToCharge.legend + ' del año ' + this.selectYear.value + '">\n</div>\n';
  }

  preLoadLayer() {

    let findLayer = this.checkLayerByYear(this.initialParameters.initialYear, this.initialParameters.initialStyle);


    if (findLayer) {
      setTimeout(() => {
        this.selectLayer(this.initialParameters.initialStyle);
      }, 10);
    } else {
      M.dialog.error(' Revise los parámetros de la URL introducida', 'ERROR - Capa ' + this.initialParameters.initialStyle + ' no encontrada');
    }
  }

  selectLayer(style) {
    let htmlSelected = document.querySelectorAll('div#gridLayer_' + style)[0];
    if (htmlSelected.classList.contains('gridLayer')) {
      htmlSelected.parentNode.parentNode.children[0].children[0].click();
      htmlSelected.children[0].click();
    } else {
      htmlSelected.parentNode.parentNode.parentNode.parentNode.children[0].children[0].click();
      htmlSelected.parentNode.parentNode.children[0].click();
      htmlSelected.children[0].click();
    }
  }

  preLoadYear() {
    this.selectYear.value = this.initialParameters.initialYear;
  }

  checkLayerByYear(year, layer) {
    let findLayer = false;
    this.groupLayers.forEach((groupData) => {
      if (groupData.theme.filter(obj => obj.year == year).length != 0) {
        let groupYear = groupData.theme.filter(obj => obj.year == year)[0].data;
        groupYear.forEach((group) => {
          if (group.layers.filter(obj => obj.style == layer).length != 0) {
            findLayer = group.layers.filter(obj => obj.style == layer)[0];
          }
        });
      }
    });

    return findLayer;
  }

  findLayerByYear(legend, year) {
    let findLayer = false;
    this.groupLayers.forEach((groupData) => {
      if (groupData.theme.filter(obj => obj.year == year).length != 0) {
        groupData.theme.filter(obj => obj.year == year)[0].data.forEach((grupo) => {
          if (grupo.layers.filter(obj => obj.legend == legend).length != 0) {
            findLayer = grupo.layers.filter(obj => obj.legend == legend)[0].style;
          }
        });
      }
    });


    return findLayer;
  }

  downloadCSV(args) {
    var data, filename, link;
    var csv = this.convertArrayOfObjectsToCSV({
      data: args.data,
      filename: args.filename
    });
    if (csv == null) return;


    filename = args.filename || 'export.csv';

    if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();

    let newDiv = document.createElement('div');
    let divContainer = document.querySelectorAll('div#searchOptions')[0];
    newDiv.id = 'okDownload';
    newDiv.innerHTML = 'Archivo <b>' + filename + '</b> descargado en Carpeta de Descargas';
    divContainer.appendChild(newDiv);
    setTimeout(() => {
      document.querySelectorAll('div#okDownload')[0].remove();
      if (this.downLoadGridButton.classList.contains('selectGridActived')) {
        this.downLoadGridButton.classList.toggle('selectGridActived');
      }
    }, 5000);
  }

  convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    var wktGeometry

    let addWKTGeometry = this.addWKTGeometry;


    data = args.data.features || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ';';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0].properties);

    result = '';
    result += keys.join(columnDelimiter);
    result += columnDelimiter + 'WKT';
    result += lineDelimiter;

    data.forEach(function (item) {

      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;

        if (item.properties[key]) {
          result += item.properties[key];
        } else {
          result += 'null';
        }

        ctr++;
      });
      if (item.geometry.type == 'Point') {
        wktGeometry = addWKTGeometry(item.geometry.type, item.geometry.coordinates);
      } else {
        wktGeometry = addWKTGeometry(item.geometry.type, item.geometry.coordinates[0]);
      }



      result += columnDelimiter + wktGeometry;

      result += lineDelimiter;
    });

    return result;
  }

  addWKTGeometry(type, coordinates) {
    let geometry = type.toUpperCase() + '(';
    if (type == 'MultiPolygon') {
      geometry += '(';
      coordinates.forEach((coord) => {
        geometry += '(';
        coord.forEach((punto) => {
          geometry += punto[0] + ' ' + punto[1] + ',';
        });
        geometry = geometry.slice(0, -1) + '),';
      });
      geometry = geometry.slice(0, -1) + '))';
    }

    if (type == 'Point') {
      geometry += coordinates[0] + ' ' + coordinates[1] + ')';
    }

    return geometry;
  }

  changeOpacity(transparency) {
    this.map_.getWMS({ name: this.layerToCharge.mainLayer })[0].setOpacity(parseFloat(transparency));
  }

  getDataWMS(evt) {
    let viewResolution = this.map_.getMapImpl().getView().getResolution();
    let srs = this.map_.getProjection().code;
    let source = this.map_.getLayers({ name: this.layerToCharge.mainLayer })[0].getImpl().getOLLayer().getSource();
    let coord = evt.coord;

    let getFeatureInfoParams = {
      INFO_FORMAT: 'application/json',
    }

    //  controlamos la representación con etiqueta o sin etiqueta en funcion de la escala

    if (this.SeleccionGrid_layer.getStyle().getOptions().name == 'Estilo_Seleccion' && this.map_.getScale() > 30000) {
      this.SeleccionGrid_layer.setStyle(this.estiloSeleccionGrid_NoLabel);
    }
    if (this.SeleccionGrid_layer.getStyle().getOptions().name == 'Estilo_Seleccion_noLabel' && this.map_.getScale() <= 30000) {
      this.SeleccionGrid_layer.setStyle(this.estiloSeleccionGrid);
    }

    //  construimos la url de getFeatureInfo  y la respuesta vendrá como un JSON

    let url = source.getFeatureInfoUrl(coord, viewResolution, srs, getFeatureInfoParams);

    M.remote.get(url).then((res) => {
      let datos = JSON.parse(res.text);

      if (datos.features.length != 0) {
        let feature = new M.Feature('', datos.features[0]);

        let id = datos.features[0].id;

        let value = datos.features[0].properties[this.mainVar];


        if (this.SeleccionGrid_layer.getFeatureById(id) === undefined) {
          if (value != -1) {
            this.sumatorioGrid += value;
            this.numberItemSelected += 1;
          } else {
            feature.setStyle(this.styleNoDato);
          }
          this.SeleccionGrid_layer.addFeatures(feature);
          if (value == -1) {
            setTimeout(() => {
              // en el caso de que la celda tenga secreto estadístico se elimina de la capa de selección a los 2 segundos
              this.SeleccionGrid_layer.removeFeatures(feature);
            }, 2000);
          }

          //  nos aseguramos que la posición del ratón sigue estando dentro del cuadrado seleccionado 
          //  si es así se cambia el puntero

          if (this.checkMousePosition(id)) {
            document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorRemoveElement + ')1 1, pointer';
          }

        } else {
          this.SeleccionGrid_layer.removeFeatures(this.SeleccionGrid_layer.getFeatureById(id));
          if (value != -1) {
            this.sumatorioGrid -= value;
            this.numberItemSelected -= 1;
          }

        }

        if (this.numberItemSelected == 0) {
          this.sumatorioGrid = 0;
          document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorAddElement + ')1 1, pointer';
        }

        if (this.sumatorioGrid - Math.trunc(this.sumatorioGrid) != 0) { //  caso de valores decimales          
          this.tableSumatorio.querySelectorAll('td')[0].innerHTML = this.sumatorioGrid.toFixed(2);
        } else {
          this.tableSumatorio.querySelectorAll('td')[0].innerHTML = this.sumatorioGrid;
        }



        if (this.numberItemSelected != 0) {
          let mean = (this.sumatorioGrid / this.numberItemSelected);
          if (mean - Math.trunc(mean) != 0) {
            this.tableSumatorio.querySelectorAll('td')[1].innerHTML = mean.toFixed(2);
          } else {
            this.tableSumatorio.querySelectorAll('td')[1].innerHTML = mean;
          }
        } else {
          this.tableSumatorio.querySelectorAll('td')[1].innerHTML = 0;
        }

        this.tableSumatorio.querySelectorAll('td')[2].innerHTML = this.numberItemSelected;
      }

    });
  }

  getMousePosition() {
    let mousePosition = this.map_.getControls({ name: 'mouse' })[0].getImpl().renderedHTML_.split(', ');
    mousePosition[0] = parseFloat(mousePosition[0]);
    mousePosition[1] = parseFloat(mousePosition[1]);
    return mousePosition;
  }

  checkMousePosition(id) {
    let mousePosition = this.getMousePosition();
    let featureTargetCoordinates = this.SeleccionGrid_layer.getFeatureById(id).getGeometry().coordinates[0][0];
    let sideLength = Math.pow((Math.pow((featureTargetCoordinates[0][0] - featureTargetCoordinates[1][0]), 2) + Math.pow((featureTargetCoordinates[0][1] - featureTargetCoordinates[1][1]), 2)), 0.5);
    let countDistance = 0;
    featureTargetCoordinates.pop();


    featureTargetCoordinates.forEach((point) => {
      let distance = Math.pow((Math.pow((point[0] - mousePosition[0]), 2) + Math.pow((point[1] - mousePosition[1]), 2)), 0.5);
      if (distance <= sideLength) {
        countDistance += 1;
      }
    });

    if (countDistance > 2) { //  si countDistance es mayor que 2 el punto está dentro del cuadrado seleccionado      
      return true;
    } else {
      return false;
    }
  }

  drawSelectionPolygon() {
    this.sourceLayer = new ol.source.Vector();
    this.layer = new ol.layer.Vector({
      source: this.sourceLayer,
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(51, 124, 235, 0.2)',
        }),
        stroke: new ol.style.Stroke({
          // color: '#337ceb',
          color: '#007932',
          width: 2,
        }),
        image: new ol.style.Circle({
          radius: 7,
          fill: new ol.style.Fill({
            color: '#007932',
          }),
        }),
      }),
      zIndex: M.impl.Map.Z_INDEX[M.layer.type.WFS] + 99,
    });
    this.map_.getMapImpl().addLayer(this.layer);


    this.i_poligono = new ol.interaction.Draw({
      type: 'Polygon',
      source: this.sourceLayer,
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(255, 255, 255, 0.5)',
        }),
        stroke: new ol.style.Stroke({
          color: '#007932',
          lineDash: [10, 10],
          width: 2,
        }),
        image: new ol.style.Circle({
          radius: 5,
          stroke: new ol.style.Stroke({
            color: '#007932',
          }),
          fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.5)',
          }),
        }),
      })
    });

    this.map_.getMapImpl().addInteraction(this.i_poligono);

    const formatoWKT = new ol.format.WKT();

    this.sourceLayer.on('change', () => {
      let features = this.sourceLayer.getFeatures();


      if (features.length != 0) {
        const wkt = formatoWKT.writeFeatures(features);


        let url = this.layerToCharge.url.replace('/wms?', '/wfs?') + 'SERVICE=WFS&VERSION=1.1.0&REQUEST=GetFeature&typeName=' + this.layerToCharge.mainLayer + '&outputFormat=application/json&CQL_FILTER=Intersects(' + this.geometryFieldName + ',' + wkt + ')';

        //  controlamos el estilo de representacion según la escala

        if (this.SeleccionGrid_layer.getStyle().getOptions().name == 'Estilo_Seleccion' && this.map_.getScale() > 30000) {
          this.SeleccionGrid_layer.setStyle(this.estiloSeleccionGrid_NoLabel);
        }
        if (this.SeleccionGrid_layer.getStyle().getOptions().name == 'Estilo_Seleccion_noLabel' && this.map_.getScale() <= 30000) {
          this.SeleccionGrid_layer.setStyle(this.estiloSeleccionGrid);
        }

        document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'progress';

        M.remote.get(encodeURI(url)).then((res) => {
          let features = JSON.parse(res.text).features;
          if (features.length != 0) {
            features.forEach((feature) => {
              let feat = new M.Feature('', feature);
              let id = feature.id;
              let value = feature.properties[this.mainVar];

              if (this.SeleccionGrid_layer.getFeatureById(id) === undefined) {
                if (value != -1) {
                  this.sumatorioGrid += value;
                  this.numberItemSelected += 1;
                  this.SeleccionGrid_layer.addFeatures(feat);
                }
              }
            });

            if (this.layerToCharge.sumationTool) {
              if (this.sumatorioGrid - Math.trunc(this.sumatorioGrid) != 0) { //  caso de valores decimales           
                this.tableSumatorio.querySelectorAll('td')[0].innerHTML = new Intl.NumberFormat('es-ES').format(this.sumatorioGrid.toFixed(2));
              } else {
                this.tableSumatorio.querySelectorAll('td')[0].innerHTML = new Intl.NumberFormat('es-ES').format(this.sumatorioGrid);
              }
            }

            if (this.numberItemSelected != 0) {
              if (this.layerToCharge.sumationTool) {
                let mean = (this.sumatorioGrid / this.numberItemSelected);
                if (mean - Math.trunc(mean) != 0) {
                  this.tableSumatorio.querySelectorAll('td')[1].innerHTML = new Intl.NumberFormat('es-ES').format(mean.toFixed(2));
                } else {
                  this.tableSumatorio.querySelectorAll('td')[1].innerHTML = new Intl.NumberFormat('es-ES').format(mean);
                }
              }
            } else {
              this.tableSumatorio.querySelectorAll('td')[1].innerHTML = 0;
            }

            this.tableSumatorio.querySelectorAll('td')[2].innerHTML = new Intl.NumberFormat('es-ES').format(this.numberItemSelected);

          }

          document.querySelectorAll('div.ol-viewport > div.ol-unselectable.ol-layers')[0].style.cursor = 'url(' + this.CursorAddElementByPolygon + ')1 1, pointer';

          setTimeout(() => {
            this.sourceLayer.clear();
          }, 1000);

        });

      }

    });

  }
}
